import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const useLegal = () => {
  const [state, setState] = useState(cache ? { data: cache } : {});
  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    api.get("/legal")
      .then(({ data }) => { cache = data; if (alive) setState({ data }); })
      .catch((e) => alive && setState({ error: e?.response?.status === 404 ? "missing" : "failed" }));
    return () => { alive = false; };
  }, []);
  return state;
};
